import 'angular';

import { AshdownEventsService }   from './ashdown.events.service';
import { AshdownInvoicesService } from './ashdown.invoices.service';
import { AshdownOrdersService }   from './ashdown.orders.service';
import { AshdownStates }          from './ashdown.states.ajs';
import { AshdownSettingsCtrl }    from './ashdown.settings';

angular.module('workshop.ashdown', [])
  .config(AshdownStates)
  .controller('AshdownSettingsCtrl', AshdownSettingsCtrl)
  .factory('AshdownEvents', AshdownEventsService)
  .factory('AshdownInvoices', AshdownInvoicesService)
  .factory('AshdownOrders', AshdownOrdersService);
